/* istanbul ignore file */

import React from 'react';
import {
  CarouselVisiblePayload,
  ClickCarouselLinkPayload,
  PillBarCarousel,
} from '@noths/polaris-client-ribbons-design-system';
import { Link } from '@noths/polaris-dev-ts-types';

import { RELATED_CATEGORIES_TITLE } from '../constants/copy';
import { RELATED_CATEGORIES_ID } from '../constants/elementIds';
import * as styles from '../styles/LinkCarousel.styles';

export interface LinkCarouselProps {
  links: Link[];
  onCarouselVisible?: (payload: CarouselVisiblePayload) => void;
  onLinkClick?: (payload: ClickCarouselLinkPayload) => void;
}

export const LinkCarousel = ({ links, onCarouselVisible, onLinkClick }: LinkCarouselProps) => {
  const handleLinkClick = (payload: ClickCarouselLinkPayload) => {
    onLinkClick?.(payload);
    window.location.href = payload.link.href!;
  };

  return links.length > 0 ? (
    <div css={styles.linkCarouselWrapper}>
      <PillBarCarousel
        onLinkClick={handleLinkClick}
        onCarouselVisible={onCarouselVisible}
        links={links}
        carouselType="related-categories"
        id={RELATED_CATEGORIES_ID}
        title={RELATED_CATEGORIES_TITLE}
      />
    </div>
  ) : null;
};
